import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../styles/partnerError.scss";

const PartnerError = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRetry = () => {
    // Clear any stored data and reload the page
    localStorage.clear();
    window.location.reload();
  };

  const handleGoBack = () => {
    // Try to go back to parent app if possible
    if (window.parent && window.parent !== window) {
      // We're in an iframe, try to communicate with parent
      try {
        window.parent.postMessage({ action: 'goBack' }, '*');
      } catch (error) {
        console.error('Could not communicate with parent window:', error);
      }
    } else {
      // Fallback to browser back
      window.history.back();
    }
  };

  return (
    <div className="partner-error-container">
      <div className="partner-error-content">
        <div className="error-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#ff6b6b" strokeWidth="2"/>
            <path d="M15 9l-6 6" stroke="#ff6b6b" strokeWidth="2" strokeLinecap="round"/>
            <path d="M9 9l6 6" stroke="#ff6b6b" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </div>
        
        <h1 className="error-title">
          {t('partnerError.title')}
        </h1>
        
        <p className="error-message">
          {t('partnerError.message')}
        </p>
        
        <p className="error-description">
          {t('partnerError.description')}
        </p>
        
        <div className="error-actions">
          <button 
            className="retry-button"
            onClick={handleRetry}
          >
            {t('partnerError.retryButton')}
          </button>
          
          <button 
            className="back-button"
            onClick={handleGoBack}
          >
            {t('partnerError.backButton')}
          </button>
        </div>
        
        <div className="contact-info">
          <p className="contact-text">
            {t('partnerError.contactText')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerError;
